import { ThemeContext } from "styled-components";
import { useContext, useMemo } from "react";
import getTheme from "./getTheme";
import selectColor from "./color";
import selectSpace from "./space";
import selectFontSize from "./fontSize";
import selectFont from "./font";
import selectWeight from "./fontWeight";
import selectRadius from "./radius";
import selectShadow from "./shadow";
import selectSpeed from "./speed";
import selectLineHeight from "./lineHeight";
export default function useSelect() {
    const theme = getTheme(useContext(ThemeContext));
    const payload = useMemo(() => ({
        color: (color) => selectColor(color, theme),
        space: (space) => selectSpace(space, theme),
        fontSize: (size) => selectFontSize(size, theme),
        font: (font) => selectFont(font, theme),
        fontWeight: (fontWeight) => selectWeight(fontWeight, theme),
        radius: (radius) => selectRadius(radius, theme),
        shadow: (shadow) => selectShadow(shadow, theme),
        speed: (speed) => selectSpeed(speed, theme),
        lineHeight: (lineHeight) => selectLineHeight(lineHeight, theme)
    }), []);
    return payload;
}
//# sourceMappingURL=useSelect.js.map